/**
 * Flag emoji for an ISO 3166-1 alpha-2 country code, or empty for anything else.
 *
 * A table rather than derived from the code's regional-indicator letters: deriving one would turn any
 * well-formed pair into *a* flag, so a code we do not know would render as the wrong country's flag
 * instead of none. It also keeps a plate prefix like "1-" out of the flags, which is not a country.
 */
const countryFlags: Record<string, string> = {
  AT: '🇦🇹',
  BE: '🇧🇪',
  BG: '🇧🇬',
  CH: '🇨🇭',
  CZ: '🇨🇿',
  DE: '🇩🇪',
  DK: '🇩🇰',
  EE: '🇪🇪',
  ES: '🇪🇸',
  FI: '🇫🇮',
  FR: '🇫🇷',
  GB: '🇬🇧',
  GR: '🇬🇷',
  HR: '🇭🇷',
  HU: '🇭🇺',
  IE: '🇮🇪',
  IT: '🇮🇹',
  LT: '🇱🇹',
  LU: '🇱🇺',
  LV: '🇱🇻',
  NL: '🇳🇱',
  NO: '🇳🇴',
  PL: '🇵🇱',
  PT: '🇵🇹',
  RO: '🇷🇴',
  SE: '🇸🇪',
  SI: '🇸🇮',
  SK: '🇸🇰',
};

/** Flag for a known ISO country code; empty when the code is missing or unknown. */
export function getCountryFlag(countryCode: string | null | undefined): string {
  if (!countryCode) {
    return '';
  }
  return countryFlags[countryCode.toUpperCase()] ?? '';
}
